// lower, upper cases, digits and special character
const regExps = [/[a-z]/, /[A-Z]/, /\d+/, /[!,@#$%&*?_~-]/]

export default function (password: string) {
  return password.length < 8 || regExps.some(exp => !password.match(exp))
}
